import { safeRedirect } from '@bimser/core';

export const removeAuth = token => {
	const loginMethod = localStorage.getItem('loginMethod');
	const logoutUrl = localStorage.getItem('externalAccountLogoutUrl');
	if (loginMethod === 'externalAccounts' && logoutUrl) {
		safeRedirect(logoutUrl);
		localStorage.removeItem('loginMethod');
		localStorage.removeItem('externalAccountLogoutUrl');
	} else {
		if (token) {
			window.location.hash = `/resetPassword/token=${token}/expired`;
			window.location.reload();
		} else {
			const externalLoginUrl = sessionStorage.getItem('externalLoginUrl');

			if (externalLoginUrl) {
				safeRedirect(externalLoginUrl);
				sessionStorage.removeItem('externalLoginUrl');
			} else {
				if (!window.location.hash.includes('/OAuth')) {
					window.location.hash = '';
				}
				window.location.reload();
			}
		}
	}
	localStorage.removeItem('token');
	sessionStorage.removeItem('token');
};
